import { Box, BoxProps, CircularProgress, Typography } from "@mui/material";
import { ReactNode } from "react";

const PORTRAIT_SIZE = 300;

export const PortraitFrame = ({
  busy = false,
  highlighted = false,
  children,
  ...boxProps
}: {
  busy?: boolean;
  highlighted?: boolean;
  children: ReactNode;
} & Pick<
  BoxProps,
  "onMouseEnter" | "onMouseLeave" | "onDragOver" | "onDragLeave" | "onDrop"
>) => (
  <Box
    position="relative"
    width={PORTRAIT_SIZE}
    maxWidth="100%"
    display="flex"
    alignItems="center"
    justifyContent="center"
    bgcolor="grey.100"
    borderRadius={1}
    overflow="hidden"
    sx={{
      aspectRatio: "1",
      outline: highlighted ? 2 : 0,
      outlineColor: "primary.main",
    }}
    {...boxProps}
  >
    {children}
    {busy && <CircularProgress sx={{ position: "absolute" }} />}
  </Box>
);

/** Several of them can be stacked in one frame, with only one of them shown */
export const FramedImage = ({
  url,
  alt,
  shown = true,
  dimmed = false,
}: {
  url: string;
  alt: string;
  shown?: boolean;
  dimmed?: boolean;
}) => (
  <Box
    component="img"
    src={url}
    alt={shown ? alt : ""}
    aria-hidden={!shown}
    position="absolute"
    width="100%"
    height="100%"
    sx={{
      inset: 0,
      objectFit: "contain",
      opacity: shown ? (dimmed ? 0.5 : 1) : 0,
      transition: "opacity 0.4s",
      "@media (prefers-reduced-motion: reduce)": { transition: "none" },
    }}
  />
);

export const SinglePortrait = ({
  imageUrl,
  alt,
  emptyLabel,
  busy = false,
}: {
  imageUrl: string | undefined;
  alt: string;
  emptyLabel: string;
  busy?: boolean;
}) => (
  <PortraitFrame busy={busy}>
    {imageUrl ? (
      <FramedImage url={imageUrl} alt={alt} dimmed={busy} />
    ) : (
      <Typography color="text.secondary">{emptyLabel}</Typography>
    )}
  </PortraitFrame>
);
